export default __webpack_public_path__ + "static/media/img3.f5197051.svg";